import { useState, useRef, useCallback } from "react";
import { FileUpload } from "primereact/fileupload";
import { Dialog } from "primereact/dialog";
import placeHolder from '../../../src/assets/images/PlaceHolder.webp';
import Cropper from "react-easy-crop";
import getCroppedImg from "../../utils/cropImageHelper"

const UploadFile = ({ label, note, preview, original, uploadHandler, uploadRef, handleDelete, isEditAllow, aspectRatio }) => {
    const [dragActive, setDragActive] = useState(false);
    const [cropVisible, setCropVisible] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const fileRef = useRef(null);
    const [cropSize, setCropSize] = useState(null);

    const onCropComplete = useCallback((_, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
        const width = Math.round(croppedAreaPixels.width);
        const height = Math.round(croppedAreaPixels.height);

        const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
        const divisor = gcd(width, height);

        const widthRatio = width / divisor;
        const heightRatio = height / divisor;

        setCropSize({
            width,
            height,
            ratio: `${widthRatio}:${heightRatio}`,
        });

    }, []);

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragActive(false);
    };

    // const handleDrop = (e) => {
    //     e.preventDefault();
    //     setDragActive(false);
    //     if (!isEditAllow) return;

    //     if (e.dataTransfer.files?.length > 0) {
    //         const file = e.dataTransfer.files[0];
    //         if (file.type.startsWith('image/')) {
    //             const reader = new FileReader();
    //             reader.onload = () => {
    //                 setImageSrc(reader.result);
    //                 setCropVisible(true);
    //                 fileRef.current = file;
    //             };
    //             reader.readAsDataURL(file);
    //         }
    //     }
    // };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        if (!isEditAllow) return;

        if (e.dataTransfer.files?.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = () => {
                    const img = new Image();
                    img.onload = () => {
                        const imageRatio = img.width / img.height;
                        let targetRatio = aspectRatio;
                        if (typeof targetRatio === 'string' && targetRatio.includes('/')) {
                            const [w, h] = targetRatio.split('/').map(Number);
                            targetRatio = w / h;
                        }
                        if (!targetRatio || Math.abs(imageRatio - targetRatio) > 0.01) {
                            setImageSrc(reader.result);
                            setCropVisible(true);
                            fileRef.current = file;
                        } else {
                            const dummyEvent = { files: [file] };
                            uploadHandler(dummyEvent);
                        }
                    };
                    img.src = reader.result;
                };
                reader.readAsDataURL(file);
            }
        }
    };

    // const handleSelectFile = ({ files }) => {
    //     const file = files[0];
    //     const reader = new FileReader();
    //     reader.onload = () => {
    //         setImageSrc(reader.result);
    //         setCropVisible(true);
    //         fileRef.current = file;
    //     };
    //     reader.readAsDataURL(file);
    // };

    const handleSelectFile = ({ files }) => {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                const imageRatio = img.width / img.height;
                let targetRatio = aspectRatio;
                if (typeof targetRatio === 'string' && targetRatio.includes('/')) {
                    const [w, h] = targetRatio.split('/').map(Number);
                    targetRatio = w / h;
                }
                if (!targetRatio || Math.abs(imageRatio - targetRatio) > 0.01) {
                    setImageSrc(reader.result);
                    setCropVisible(true);
                    fileRef.current = file;
                } else {
                    const dummyEvent = { files: [file] };
                    uploadHandler(dummyEvent);
                }
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    };

    const applyCrop = async () => {
        const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, fileRef.current.name);
        const dummyEvent = { files: [croppedImage] };
        uploadHandler(dummyEvent);
        setCropVisible(false);
        setImageSrc(null);
    };

    return (
        <div className="p-d-flex p-jc-center" style={{height:'inherit'}}>
            <label>{label}{note ? <span style={{ color: "red" }}>{note}</span> : ''}</label>
            <div
                className={`drop-zone ${dragActive ? 'active-drop' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    padding: "10px",
                    borderRadius: "8px",
                    transition: "border 0.3s",
                    width: '100%',
                    height: '100%',
                    position: 'relative'
                }}
            >
                <img
                    src={preview || original || placeHolder}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = placeHolder;
                    }}
                    alt="preview"
                    className="upload-preview"
                    style={{
                        width: 'inherit',
                        height: 'inherit',
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }}
                />
                {isEditAllow &&
                    <div className='user-profile-btn profile-position p-mt-3 p-d-flex p-ai-center p-jc-center'>
                        {!preview && (
                            <FileUpload
                                ref={uploadRef}
                                name='importFile'
                                customUpload
                                auto
                                mode="basic"
                                uploadHandler={handleSelectFile}
                                className="small-file-upload"
                                accept="image/*"
                            />
                        )}
                        {(original || preview) && (
                            <div
                                className="error-msg-alert p-ml-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(label)}
                            >
                                <i className="pi pi-trash" style={{ fontSize: "16px", color: "red" }}></i>
                            </div>
                        )}
                    </div>}
                {/* <p style={{ fontSize: "12px", color: "#888", marginTop: "0.5rem" }}>
                    Drag & drop image here to update
                </p> */}
            </div>
            <Dialog
                header="Crop Image"
                visible={cropVisible}
                style={{ width: '400px' }}
                modal
                onHide={() => setCropVisible(false)}
                footer={
                    <div className="p-d-flex p-jc-end">
                        <button className="p-button p-button-sm" onClick={applyCrop}>Crop & Upload</button>
                    </div>
                }
            >
                <div style={{ position: 'relative', width: '100%', height: 300 }}>
                    {imageSrc && (
                        <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={aspectRatio || undefined}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                        />
                    )}
                </div>
                {cropSize && (
                    <div style={{ textAlign: "center", marginTop: 10, color: "#555" }}>
                        Selected Crop: {cropSize.width} x {cropSize.height} px<br />
                        Ratio: {cropSize.ratio}
                    </div>
                )}
            </Dialog>
        </div>
    );
};

export default UploadFile;
